import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export const ReadOnlyBanner: React.FC<{ isHidden?: boolean }> = ({
  isHidden,
}) => {
  const getClassName = () => {
    const bannerClasses = {
      [styles['read-only-banner']]: true,
      [styles['hidden']]: isHidden,
      banner: true,
      'layout-context-compact': true,
    };
    return clsx(bannerClasses);
  };
  return (
    <div className={getClassName()} data-testid="read-only-banner">
      <span className="font-weight-normal">
        You are viewing the curriculum in
        <span className={clsx(styles['mode-label'], 'font-weight-bolder')}>
          Read Only Mode.
        </span>
      </span>
      <span className="font-weight-normal">
        Certain functionalities are not available.
        <a
          target="_blank"
          rel="noreferrer"
          className={clsx('amp-link', 'link-light', styles['learn-more-link'])}
          href={''}
        >
          Learn More
        </a>
      </span>
    </div>
  );
};
